import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logo-cropped.png";

import "../../styles/garage/garage-main.css";

export default function Navigation() {
    return (
        <nav className="garage-navigation-landing">

            <a href="https://mycarapp.co.ke" className="logo">
                <img
                    src={logo}
                    alt="Garage Management"
                />
            </a>

            <div className="nav-links">

                <a href="#features">
                    Features
                </a>

                <a href="#pricing">
                    Pricing
                </a>

                <a href="#faq">
                    FAQ
                </a>

            </div>

            <div className="nav-actions">

                <button className="themed"> <Link
                    to="https://garage.mycarapp.co.ke/garage-login"
                    className="login-button"
                >
                    Login
                </Link></button>

            </div>

        </nav>
    );
}